import React from 'react'
import { TABLE_TYPE, withTableContext } from '../../context/TableContext'
import { EKOM_LINKS } from '../../EKOM_LINKS'
import { useMsgsList } from '../../hooks/useMsgsList'
import { MsgsTable } from '../MsgsTable/MsgsTable'

interface iMsgsReceivedList {
  extSystemId: string
  extObjectId: string
  relatedId?: string
}

const MsgsReceivedListMin = ({ extSystemId, extObjectId, relatedId }: iMsgsReceivedList) => {

  const heads = [
    { id: 'deliveredAt', label: 'Datum ' },
    { id: 'state', label: '' },
    { id: 'subject', label: 'Předmět' },
    { id: 'attachment', label: '' },
    { id: 'senderOrganizationName', label: 'Odesílatel' },
  ]
  const { data, error, loading, totalCount } = useMsgsList(false, extSystemId, extObjectId, relatedId)

  const tableData = data.map(msg => ({
    id: msg.id,
    deliveredAt: msg.deliveredAt,
    subject: msg.subject,
    link_subject: EKOM_LINKS.listRecv + '/' + msg.id,
    senderOrganizationName: msg.senderOrganizationName,
    attachment: msg.attachmentCount,
    isRead: !!msg.readsCount,
    state: msg.extType?.name,
  }))

  return (
    <MsgsTable
      loading={loading}
      error={error}
      heads={heads}
      data={tableData}
      totalCount={totalCount}
      noFilter
    />
  )
}

export default withTableContext(MsgsReceivedListMin, TABLE_TYPE.IN, false)
